var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFridgecheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8405 32.1556H10.0819C8.35774 32.1556 6.95453 30.6942 6.95453 28.8978V3.25843C6.95453 1.46144 8.35774 0 10.0819 0H24.84C26.5653 0 27.968 1.46144 27.968 3.25843V28.8978C27.968 30.6942 26.5653 32.1556 24.8405 32.1556ZM10.0819 2.05728C9.4464 2.05728 8.92962 2.59626 8.92962 3.25787V28.8972C8.92962 29.5594 9.44693 30.0984 10.0819 30.0984H24.84C25.4756 30.0984 25.9923 29.5594 25.9923 28.8978V3.25843C25.9923 2.59626 25.475 2.05784 24.84 2.05784L10.0819 2.05728Z",
    fill: "#395723"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0938 34H9.30476C9.18854 34 9.09442 33.5012 9.09442 32.8853C9.09442 32.2693 9.18865 31.7705 9.30476 31.7705H12.0938C12.21 31.7705 12.3042 32.2693 12.3042 32.8853C12.3042 33.5012 12.2099 34 12.0938 34Z",
    fill: "#395723"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9329 34H22.1439C22.0277 34 21.9336 33.5012 21.9336 32.8853C21.9336 32.2693 22.0278 31.7705 22.1439 31.7705H24.9329C25.0492 31.7705 25.1434 32.2693 25.1434 32.8853C25.1434 33.5012 25.049 34 24.9329 34Z",
    fill: "#395723"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9621 8.27271C12.5901 8.27271 9.04547 11.8172 9.04547 16.1894C9.04547 20.5616 12.5901 24.106 16.9621 24.106C21.3347 24.106 24.8788 20.5616 24.8788 16.1894C24.8788 11.8172 21.3345 8.27271 16.9621 8.27271ZM15.5099 20.256L12.024 16.7703L13.1859 15.6084L15.5099 17.9323L20.7384 12.7037L21.9002 13.8655L15.5099 20.256Z",
    fill: "#6AC259"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6818,
    height: 14.6818,
    fill: "white",
    transform: "translate(10.0455 9.27271)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFridgecheck);
export default __webpack_public_path__ + "static/media/fridgecheck.88f23a32920e1f006408305a1547514e.svg";
export { ForwardRef as ReactComponent };